import type { TimeSignature } from './ecoRitmoConfig';

export interface TrainSpriteSlot {
  left: string;
  top: string;
  width: string;
  height: string;
}

export interface TrainSpriteDef {
  /** Imagen principal (ideal ~1280 px de ancho). */
  src: string;
  /** Versión Retina opcional (mayor resolución). */
  src2x?: string;
  /** Ancho / alto del sprite. */
  aspectRatio: number;
  slots: TrainSpriteSlot[];
}

/** Sprites por compás — ventanas calibradas sobre PNG exportados. */
export const TRAIN_SPRITES: Partial<Record<TimeSignature, TrainSpriteDef>> = {
  '2/4': {
    src: '/junior-assets/images/2vagones.png',
    aspectRatio: 2,
    slots: [
      { left: '29.8%', top: '29.1%', width: '15.9%', height: '26.1%' },
      { left: '60.8%', top: '28.7%', width: '16.3%', height: '26.6%' },
    ],
  },
  '3/4': {
    src: '/junior-assets/images/3vagones.png',
    src2x: '/junior-assets/images/3vagones@2x.png',
    aspectRatio: 2814 / 1536,
    slots: [
      { left: '16.0%', top: '35.9%', width: '14.1%', height: '21.2%' },
      { left: '43.4%', top: '35.7%', width: '14.4%', height: '21.5%' },
      { left: '70.9%', top: '35.8%', width: '14.4%', height: '21.4%' },
    ],
  },
  '4/4': {
    src: '/junior-assets/images/4vagones.png',
    aspectRatio: 1280 / 640,
    /** Ventanas sobre 4vagones.png (1280×640) — huecos negros de cada vagón. */
    slots: [
      { left: '4.0%', top: '25.5%', width: '12.0%', height: '33.0%' },
      { left: '21.5%', top: '25.5%', width: '12.0%', height: '33.0%' },
      { left: '44.0%', top: '25.5%', width: '12.0%', height: '33.0%' },
      { left: '72.0%', top: '25.5%', width: '12.5%', height: '33.5%' },
    ],
  },
};

export function trainSpriteForSignature(ts: TimeSignature): TrainSpriteDef | null {
  return TRAIN_SPRITES[ts] ?? null;
}
